function repositionCategory() {
  repoTopBannerCategory();
}

function repoTopBannerCategory() {
  if ($(".banner-category-top").length) {
    $(".banner-category-top").insertBefore(".category-top");
  }
  if ($(".pagination-link.up > span").length === 0) {
    $(".pagination-link.up").append("<span>Nahoru</span>");
  }
  if ($("#productsTop").length) {
    createSliderFromProductTopImages();
  }
}

function createSliderFromProductTopImages() {
  $("#productsTop").each(function () {
    var productsItems = $(this);

    var productsSlide = productsItems.find(".product");

    productsSlide.wrap('<div class="swiper-slide"></div>');

    productsItems.wrapInner(
      '<div class="swiper-container js-slider-products-top"></div>'
    );

    productsItems
      .find(".swiper-container")
      .wrapInner('<div class="swiper-wrapper"></div>');

    productsItems.wrapInner(
      '<div class="js-slider-group slider-group-products"></div>'
    );

    var paginationTemplate =
      '<div class="swiper-pagination js-swiper-pagination"></div>';

    productsItems.find(".slider-group-products").append(paginationTemplate);

    var arrowTemplate =
      '<div class="swiper-arrow swiper-arrow-next js-swiper-arrow-next">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>" +
      '<div class="swiper-arrow swiper-arrow-prev js-swiper-arrow-prev">' +
      '<div class="swiper-arrow-content">' +
      "<span></span>" +
      "</div>" +
      "</div>";
    productsItems.find(".slider-group-products").append(arrowTemplate);

    productsTopImagesSlider();
  });
}

function productsTopImagesSlider() {
  if ($(".js-slider-products-top").length) {
    $(".js-slider-products-top").each(function () {
      var inst = $(this),
        swiperBlock = inst.closest(".js-slider-group"),
        swiperPagination = swiperBlock.find(".js-swiper-pagination"),
        swiperArrowPrev = swiperBlock.find(".js-swiper-arrow-prev"),
        swiperArrowNext = swiperBlock.find(".js-swiper-arrow-next");

      var productsTopBreakpoints = {
        200: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 3,
          // slidesPerGroup: 1,
        },
        771: {
          slidesPerView: 2,
          // slidesPerGroup: 1,
        },
        992: {
          slidesPerView: 3,
          // slidesPerGroup: 1,
        },
        1200: {
          slidesPerView: 3,
          // slidesPerGroup: 1,
        },
        1440: {
          slidesPerView: 4,
          // slidesPerGroup: 1,
        },
      };

      var mySwiper = new Swiper(inst, {
        spaceBetween: 0,
        lazy: true,
        loop: true,
        speed: 600,
        pagination: {
          el: swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: swiperArrowNext,
          prevEl: swiperArrowPrev,
        },
        breakpoints: productsTopBreakpoints,
      });
    });
  }
}
